module.exports = __webpack_public_path__ + "assets/img/29_405.e3add6a3.jpg";